// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LiveAgentBotSettings.module.css - Updated without session toggle styles */

.LiveAgentBotSettings_botContent_wrap__X2Nr6 {
  /* padding: 20px; */
  width: 100%;
  /* margin: 0 auto; */
  min-height: 700px;
}

.LiveAgentBotSettings_title__cJYk9 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.LiveAgentBotSettings_centered__1f6j6 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Update Button Styles */
.LiveAgentBotSettings_updateBtn__bFosV {
  background-color: var(--saveBtn);
  color: var(--white-color);
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 24px;
  width: 100%;
  max-width: 200px;
}

.LiveAgentBotSettings_updateBtn__bFosV:hover:not(:disabled) {
  background-color: var(--saveHover);
}

.LiveAgentBotSettings_updateBtn__bFosV:disabled {
  background-color: var(--cancelBtn);
  cursor: not-allowed;
  opacity: 0.7;
  color: var(--heading);
}

.LiveAgentBotSettings_disabled__FmvXk {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .LiveAgentBotSettings_botContent_wrap__X2Nr6 {
    padding: 16px;
  }

  .LiveAgentBotSettings_title__cJYk9 {
    font-size: 20px;
  }

  .LiveAgentBotSettings_updateBtn__bFosV {
    width: 100%;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/LiveAgentBotSettings/LiveAgentBotSettings.module.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* LiveAgentBotSettings.module.css - Updated without session toggle styles */\n\n.botContent_wrap {\n  /* padding: 20px; */\n  width: 100%;\n  /* margin: 0 auto; */\n  min-height: 700px;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 24px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.centered {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Update Button Styles */\n.updateBtn {\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 24px;\n  width: 100%;\n  max-width: 200px;\n}\n\n.updateBtn:hover:not(:disabled) {\n  background-color: var(--saveHover);\n}\n\n.updateBtn:disabled {\n  background-color: var(--cancelBtn);\n  cursor: not-allowed;\n  opacity: 0.7;\n  color: var(--heading);\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .botContent_wrap {\n    padding: 16px;\n  }\n\n  .title {\n    font-size: 20px;\n  }\n\n  .updateBtn {\n    width: 100%;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botContent_wrap": `LiveAgentBotSettings_botContent_wrap__X2Nr6`,
	"title": `LiveAgentBotSettings_title__cJYk9`,
	"centered": `LiveAgentBotSettings_centered__1f6j6`,
	"updateBtn": `LiveAgentBotSettings_updateBtn__bFosV`,
	"disabled": `LiveAgentBotSettings_disabled__FmvXk`
};
export default ___CSS_LOADER_EXPORT___;
